<template>
	<div class="group-register-view">
		<div class="group-hero-view">
			<div
				class="heroImage"
				:style="{
					backgroundImage: group && 'url(' + group.cover_url + ')'
				}"
			/>
		</div>
		<div class="group-body">
			<div
				class="roundup-row"
				style="
					justify-content: space-between;
					margin-bottom: 10px;
					margin-top: 0px;
				"
			>
				<div class="powered-by-logo" />
				<ui-button
					class="white"
					:style="{
						marginTop: 0,
						height: 32,
						padding: '5px 20px',
						fontSize: '16px'
					}"
					@click="navigate({ name: 'login' }, 'up')"
					>Login</ui-button
				>
			</div>
			<div
				class="roundup-row"
				style="
					justify-content: space-around;
					flex-wrap: wrap;
					margin-bottom: 10px;
					margin-top: 0px;
					align-items: flex-start;
				"
			>
				<div class="group-info" v-if="group">
					<h1>{{ group.name }}</h1>
					<p class="description" v-html="groupInfo"></p>
					<div class="fact">{{ group.fact }}</div>
					<h2>Included Organizations</h2>
					<div class="image-group">
						<img
							v-for="inst in group.institutions"
							:key="inst.id"
							:src="inst.logo_url"
							class="inst-logo"
							@click="openOrg(inst.website_url)"
						/>
					</div>
					<a
						href="https://www.roundupapp.com/environmental-cause-funds"
						target="_blank"
						>View All Cause Funds</a
					>
				</div>
				<div class="register-form" v-if="group">
					<div
						class="roundup-row"
						style="justify-content: flex-start"
					>
						<div
							class="icon"
							:style="{
								backgroundImage:
									this.group && 'url(' + this.group.icon + ')'
							}"
						></div>
						<h3 style="margin-left: 10px">
							Start supporting {{ group.name }}
						</h3>
					</div>
					<form
						v-on:submit.prevent="onSubmit"
						style="margin-bottom: 10px; margin-top: 15px"
					>
						<label>
							<ui-input
								type="white"
								v-model="user.first_name"
								placeholder="First Name"
							/>
						</label>
						<label>
							<ui-input
								type="white"
								v-model="user.last_name"
								placeholder="Last Name"
							/>
						</label>
						<label>
							<p
								v-if="this.message"
								v-bind:style="{ fontSize: '12px' }"
							>
								{{ this.message }}
							</p>
							<ui-input
								type="white"
								v-model="user.phone"
								placeholder="Phone"
								@input="onlyNumber($event)"
							/>
						</label>
						<label>
							<ui-input
								type="white"
								v-model="user.email"
								placeholder="Email"
							/>
						</label>
						<label>
							<ui-input
								v-model="user.password"
								placeholder="Password"
								type="white"
								native-type="password"
							/>
						</label>
						<label>
							<p class="terms">
								By continuing, I confirm I am a U.S. resident,
								13 years or older and agree to the
								<a href="https://roundupapp.com/terms"
									>Terms of Use</a
								>.
							</p>
							<ui-button
								style="width: 80%"
								native-type="submit"
								:loading="isLoading"
								>Sign Up</ui-button
							>
						</label>
					</form>
					<a
						class="terms"
						:style="{ marginTop: '10px', fontSize: '14px' }"
						href="#/login"
						>Already have an account? Login</a
					>
				</div>
			</div>
			<h1>How it works</h1>
			<div
				class="roundup-row"
				style="
					justify-content: space-around;
					flex-wrap: wrap;
					margin-bottom: 10px;
					margin-top: 0px;
					align-items: initial;
				"
			>
				<div class="steps">
					<div class="step">
						<div class="number" style="background-color: #3770fe">
							1
						</div>
						<h4>Create Your Account</h4>
						<p>
							Fill out the form on this page with your name,
							phone, email and a password of your choosing, and
							you’re all set.
						</p>
					</div>
					<div class="step">
						<div class="number" style="background-color: #ff6376">
							2
						</div>
						<h4>Link Your Cards</h4>
						<p>
							Add a payment card, and then link your credit or
							debit cards to securely authorize RoundUps with the
							issuing banks.
						</p>
					</div>
					<div class="step">
						<div class="number" style="background-color: #1cd4e3">
							3
						</div>
						<h4>Make An Impact</h4>
						<p>
							The extra change from each transaction you make will
							be "rounded up" to the next dollar and donated each
							month to this Cause Fund<sup>*</sup>.
						</p>
					</div>
				</div>
				<div
					style="
						flex: 2 1;
						display: block;
						height: 0;
						margin-right: 15px;
						min-width: 350px;
					"
				></div>
			</div>
			<p style="font-style: italic; padding-bottom: 25px">
				* We divide your donation equally among all included
				organizations.
			</p>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { getUrlParams } from '../../utilities'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import { facebook } from '../../utilities/tracker'

export default {
	name: 'group-register-view',
	components: { UiButton, UiInput },
	props: {
		uuid: String
	},
	data() {
		return {
			isLoading: false,
			noInstitution: false,
			user: {
				first_name: '',
				last_name: '',
				email: '',
				password: '',
				phone: '',
				group: this.uuid,
				referred_by: null
			},
			group: null,
			message: ''
		}
	},
	computed: {
		title() {
			if (this.group) {
				return 'Support ' + this.group.name + ' By Donating Your Change'
			}
			return 'RoundUp App'
		},
		heroImage() {
			return this.group
				? 'url(' + this.group.cover_url + ') 0 0 fixed'
				: 'none'
		},
		description() {
			if (!this.group) {
				return false
			}
			return (
				'Round up and donate your change to support ' +
				this.group.name +
				'! Sign up in seconds to donate the change from your credit/debit card purchases so ' +
				this.group.name +
				' can improve our world.' +
				this.group.fact +
				'.'
			)
		},
		groupInfo() {
			if (!this.group) {
				return ''
			}
			return this.group.description.replace(/(\\r)*\\n/g, '<br>')
		},
		image() {
			if (!this.group) {
				return false
			}
			if (!this.group.cover_url) {
				this.navigate({ name: 'home' })
			}
			return this.group.cover_url
		}
	},
	head: {
		title() {
			return {
				inner: this.title
			}
		},
		meta() {
			return [
				{ name: 'description', content: this.description },
				// Twitter
				{
					name: 'twitter:title',
					content: this.title,
					id: 'twitter_title'
				},
				{
					name: 'twitter:description',
					content: this.description,
					id: 'twitter_desc'
				},
				{
					name: 'twitter:image',
					content: this.image,
					id: 'twitter_image'
				},
				// Google+ / Schema.org
				{ itemprop: 'name', content: this.title, id: 'google_title' },
				{
					itemprop: 'description',
					content: this.description,
					id: 'google_desc'
				},
				{ itemprop: 'image', content: this.image, id: 'google_image' },
				// Facebook / Open Graph
				{ property: 'og:title', content: this.title, id: 'fb_title' },
				{
					property: 'og:description',
					content: this.description,
					id: 'fb_desc'
				},
				{ property: 'og:image', content: this.image, id: 'fb_image' }
			]
		}
	},
	methods: {
		...mapActions(['register', 'getGroup']),
		onSubmit() {
			if (this.user.phone.length < 10 || this.user.phone.length > 11) {
				this.$swal('Error', 'Please enter a valid phone number.')
				return
			}
			this.isLoading = true
			this.register(this.user)
				.then((data) => {
					this.isLoading = false
					if (data.group_id) {
						this.$router.go({
							name: 'mindonation',
							params: { onboarding: true }
						})
						window.analytics.track('deep_group_register', {
							group_id: this.group.id
						})
						facebook.track('CompleteRegistration', {
							first_name: this.user.first_name,
							last_name: this.user.last_name,
							email: this.user.email,
							value: 255.84,
							currency: 'USD'
						})
					} else {
						this.$router.go({
							name: 'mindonation',
							params: { onboarding: true }
						})
					}
				})
				.catch((error) => {
					this.isLoading = false
					this.$swal(error.message)
				})
		},
		appendToFilename(filename, string) {
			var dotIndex = filename.lastIndexOf('.')
			if (dotIndex === -1) return filename + string
			else
				return (
					filename.substring(0, dotIndex) +
					string +
					filename.substring(dotIndex)
				)
		},
		downgradeImage(el) {
			el.srcElement.src = this.institution.image_url
		},
		onlyNumber(evt) {
			const clean = evt.replace(/\D+/g, '')
			if (clean !== evt) {
				this.message = 'Numbers only please :)'
			} else {
				this.message = null
			}
			this.user.phone = clean
		},
		openOrg(url) {
			window.open(url, '_blank')
		}
	},
	mounted() {
		// eslint-disable-next-line no-console
		this.getGroup(this.uuid).then((group) => {
			this.group = group

			this.$emit('updateHead')
		})

		const urlParams = getUrlParams(window.location.href)
		this.user.referred_by = urlParams.referred_by

		var parent = document.getElementById('parent')
		parent.style.maxWidth = 'none'
		parent.style.position = 'none'
	}
}
</script>

<style lang="scss" scoped>
.group-register-view {
	.group-hero-view {
		right: 0;
		left: 0;
		top: 0;
		position: absolute;
		text-align: left;

		@media screen and (max-width: 960px) {
			left: 0;
		}
		@media screen and (max-width: 480px) {
			margin-top: 0px;
		}
		.heroImage {
			height: 500px;
			background-repeat: no-repeat;
			background-attachment: fixed;
			background-position: center top;
			background-size: contain;
		}
	}
	.group-body {
		padding-top: 20px;
		padding-left: 25px;
		padding-right: 25px;
		max-width: 1250px;
		margin: auto;
		margin-bottom: 25px;
		position: relative;
		text-align: left;
		font-family: Work Sans, sans-serif;
		font-weight: 400;
		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			font-family: Work Sans, sans-serif;
			color: $charcoal;
			font-weight: 600;
		}
		h1 {
			font-size: 32px;
		}
		h2 {
			font-size: 24px;
		}
		h3 {
			font-size: 18px;
		}
		h4 {
			font-size: 16px;
		}
		p {
			font-size: 16px;
			color: $charcoal;
		}
		@media screen and (max-width: 1250px) {
			max-width: 960px;
		}
		@media screen and (max-width: 960px) {
			max-width: 750px;
		}
		@media screen and (max-width: 480px) {
			max-width: 450px;
		}
		.powered-by-logo {
			background: url('../../assets/roundup_logo_white.svg');
			background-size: contain;
			background-repeat: no-repeat;
			height: 30px;
			width: 300px;
			position: relative;
			@media screen and (max-width: 600px) {
				height: 15px;
				width: 150px;
			}
		}
		.group-info {
			flex: 4 1;
			padding: 15px;
			padding-bottom: 25px;
			background: #fff;
			margin-right: 10px;
			display: block;
			min-width: 350px;
			border-top: 10px solid $bluegrad2;
			border-radius: 20px;
			justify-content: flex-start;
			align-items: flex-start;
			text-align: left;
			box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
			.description {
				margin-top: 25px;
			}
			.fact {
				margin: 30px -15px 40px -15px;
				padding: 25px;
				padding-bottom: 25px;
				text-align: center;
				background-image: linear-gradient($bluegrad1, $bluegrad2);
				color: #fff;
				font-size: 24px;
			}
			.image-group {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				width: 100%;
				padding-top: 0px;
				display: block;
			}
			.inst-logo {
				width: 100px;
				border-radius: 10px;
				height: auto;
				margin: 15px;
				cursor: pointer;
				@media screen and (max-width: 960px) {
					margin-right: 0px;
					width: 100%;
					max-width: 600px;
					margin-bottom: 25px;
					.description {
						margin-top: 20px;
					}
					.fact {
						margin-top: 15px;
						margin-bottom: 20px;
					}
				}
				@media screen and (max-width: 480px) {
					max-width: 450px;
					margin-bottom: 25px;
					margin-right: 0px;
					.description {
						margin-top: 15px;
					}
				}
				@media screen and (max-width: 400px) {
					width: 100%;
					margin-left: 10px;
					margin-right: 10px;
				}
				.description {
					margin-top: 10px;
				}
				.fact {
					margin-top: 10px;
					margin-bottom: 15px;
				}
			}
		}
		.register-form {
			flex: 2 1;
			background: #fff;
			padding: 15px;
			margin-left: 10px;
			display: block;
			min-width: 350px;
			border-top: 10px solid $bluegrad2;
			border-radius: 20px;
			box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
			h3 {
				text-align: left;
			}
			.icon {
				height: 50px;
				width: 50px;
				min-width: 50px;
				border-radius: 25px;
				border: 2px solid $bluegrad2;
				margin-right: 10px;
				background-repeat: no-repeat;
				background-position: center;
				background-size: 32px 32px;
			}
			label {
				padding-bottom: 10px;
				display: block;
				@media screen and (max-width: 960px) {
					margin-right: 0px;
					width: 100%;
					max-width: 600px;
					margin-bottom: 25px;
				}
				@media screen and (max-width: 480px) {
					max-width: 450px;
					margin-bottom: 25px;
					margin-left: 0px;
				}
				@media screen and (max-width: 400px) {
					width: 100%;
					margin-left: 10px;
					margin-right: 10px;
					margin-bottom: 25px;
				}
			}
		}
		.steps {
			flex: 4 1;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin-right: 10px;
			flex-wrap: wrap;
			align-items: flex-start;
			.step {
				flex: 1 1 100%;
				width: 200px;
				max-width: 250px;
				margin: auto;
				margin-bottom: 25px;
				margin-left: 5px;
				margin-right: 5px;
				align-items: center;
				display: flex;
				flex-direction: column;
				height: 100%;
				.number {
					color: #fff;
					font-size: 32px;
					height: 64px;
					width: 64px;
					margin-top: 0px;
					text-align: center;
					justify-content: center;
					font-weight: 900;
					border-radius: 32px;
					line-height: 64px;
				}
				p {
					font-size: 16px;
					text-align: left;
					margin-top: 0px;
					@media screen and (max-width: 1250px) {
						height: auto;
					}
				}
				&:first-child {
					margin-left: 0px;
				}
				&:last-child {
					margin-right: 0px;
					@media screen and (max-width: 960px) {
						margin-right: 0px;
						justify-content: center;
					}
					.step {
						width: 300px;
						max-width: 100%;
						height: auto;
					}
				}
			}
		}
		.roundup-button {
			width: auto;
			border-radius: 25px;
			cursor: pointer;
			font-weight: 600;
			margin-top: 20px;
			padding: 15px 25px;
			position: relative;
			text-decoration: none;
			@media screen and (max-width: 400px) {
				font-size: 14px;
				padding: 10px 20px;
			}
		}
	}
}
</style>
